import { useState } from "react";
import { supabase } from "../lib/supabase";
import { Wordmark } from "../components/Wordmark";

export function SignIn() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [status, setStatus] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function signIn(e: React.FormEvent) {
    e.preventDefault();
    setBusy(true);
    setStatus(null);
    const { error } = await supabase.auth.signInWithPassword({ email, password });
    // Deliberately vague: never reveal whether an address has an account.
    if (error) setStatus("Those details did not work. Check them and try again.");
    setBusy(false);
  }

  async function emailLink() {
    setBusy(true);
    setStatus(null);
    const { error } = await supabase.auth.signInWithOtp({ email });
    setStatus(
      error
        ? "We could not send that link. Try again in a moment."
        : "If that address has an account, a sign-in link is on its way.",
    );
    setBusy(false);
  }

  return (
    <main className="auth">
      <div className="card">
        <div className="signin-mark"><Wordmark height={48} /></div>
        <h1>Sign in</h1>
        <p className="muted">Use the address your invitation was sent to.</p>
        <form onSubmit={signIn}>
          <label htmlFor="email">Email</label>
          <input
            id="email"
            type="email"
            autoComplete="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          <label htmlFor="password">Password</label>
          <input
            id="password"
            type="password"
            autoComplete="current-password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
          />
          <p className="field-hint">
            No password yet? Leave it blank and use the emailed link instead.
          </p>
          <button className="btn" type="submit" disabled={busy || !email || !password}>
            {busy ? "Checking\u2026" : "Sign in"}
          </button>
        </form>

        {/* The two routes in are not equal, and two stacked full-width buttons
            said they were. */}
        <p className="or">or</p>
        <button className="btn ghost" onClick={emailLink} disabled={busy || !email}>
          Email me a sign-in link
        </button>
        {status && <p className="status">{status}</p>}
      </div>
    </main>
  );
}
